module.exports = __webpack_public_path__ + "static/media/orderCheck.117aa382.svg";